'use client';
import React__default, { useRef } from 'react';
import PropTypes from 'prop-types';
import icons from '../../../assets/icons/index.js';
import { CheckboxContainer, PseudoCheckbox, StyledLabel } from './Checkbox.styles.js';
import { CHECKBOX_SIZES, CHECKBOX_ICON_SIZES } from './Checkbox.constants.js';

var Checkbox = function Checkbox(_ref) {
  var id = _ref.id,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? CHECKBOX_SIZES.REGULAR : _ref$size,
    label = _ref.label,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    _ref$indeterminate = _ref.indeterminate,
    indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var checkboxElement = useRef();
  var Icon = icons[checked ? 'TickDone' : 'Minus'];
  var handlePseudoChange = function handlePseudoChange(e) {
    if (!disabled && (e.key === 'Enter' || e.type === 'click')) {
      checkboxElement.current.click();
    }
  };
  var isChecked = checked || indeterminate;
  return React__default.createElement(CheckboxContainer, {
    $checked: isChecked,
    $disabled: disabled,
    "data-testid": testId
  }, React__default.createElement(PseudoCheckbox, {
    $size: size,
    $checked: isChecked,
    $disabled: disabled,
    tabIndex: disabled ? '-1' : '0',
    onKeyDown: handlePseudoChange,
    onClick: handlePseudoChange
  }, isChecked && React__default.createElement(Icon, {
    width: CHECKBOX_ICON_SIZES[size]
  })), React__default.createElement("input", {
    ref: checkboxElement,
    type: "checkbox",
    name: label,
    id: id,
    checked: isChecked,
    "aria-label": label,
    onChange: onChange,
    tabIndex: "-1",
    disabled: disabled,
    "aria-checked": !checked && !indeterminate ? 'false' : checked || 'mixed'
  }), React__default.createElement(StyledLabel, {
    htmlFor: id,
    $size: size,
    $withLabel: withLabel
  }, label));
};
Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  indeterminate: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(Object.values(CHECKBOX_SIZES)),
  testId: PropTypes.string,
  withLabel: PropTypes.bool
};

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map
